import { getRootScope } from '../helper-utils';

class BuildingsTopNav {
    constructor($window, $timeout, $rootScope, $templateCache) {
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;

        this.scope = {
            buildings: '=',
            selectedBuilding: '='
        };

        this.$element = null;
        this.template = this.getTemplate();
        this.link = this.BuildingsTopNavLink;
    }

    getTemplate() {
        const template = this.$templateCache.get('nav-bar/top/buildings-top-nav-tmpl.html');
        return template;
    }

    init(scope, element) {
        scope.changeBuilding = this.changeBuilding;
        this.isMobile = false;
        this.scopeReference = scope;
        this.scopeReference.$element = angular.element(element);
        this.scopeReference.toggleBuildingList = this.toggleBuildingList;

        this._registerEventHandling();
    }

    toggleBuildingList() {
        const $arrow = angular.element('#buildingsNav i.fas', this.$element);
        const $buildingList = angular.element('#userBuildings', this.$element);

        if ($buildingList && $buildingList.length > 0) {
            const isShowing = $buildingList.hasClass('in');

            if (isShowing) {
                $arrow.addClass('fa-chevron-down');
                $arrow.removeClass('fa-chevron-up');
            } else {
                $arrow.addClass('fa-chevron-up');
                $arrow.removeClass('fa-chevron-down');
            }
        }
    }

    BuildingsTopNavLink(scope, element, attrs) {
        const { buildings } = scope;

        scope.buildings = this._mapBuildings(buildings);
        this.init(scope, element);
    }


    changeBuilding(buildingReference) {
        const mapped = this.buildings.map((building) => {
            const { SchemeReference: schemeReference } = building;
            let isSelected = false;
            const mobileWidth = 991;
            let isMobileScreen = false;
            const screenWidth = $('body').width();

            if (schemeReference === buildingReference) {
                isSelected = true;
            }

            if (screenWidth <= mobileWidth) {
                isMobileScreen = true;
            }
            let tempImgUrl = "";
            if (!isMobileScreen) {
                tempImgUrl = this.getTrustedBuildingImageUrl(schemeReference);
            }
            const imgUrl = tempImgUrl;
            const $buildingList = angular.element('#userBuildings', this.$element);

            if ($buildingList.hasClass('in')) {
                $buildingList.removeClass('in');
            }
            return {
                imgUrl,
                ...building,
                isSelected
            };
        });


        this.buildings = mapped;
        this.$parent.$emit('selected-building-changed', buildingReference);
    }

    getTrustedBuildingImageUrl(schemeReference) {

        const imgUrl = this.$sce.trustAsResourceUrl(
            `${PretorCDNAddress}/images/buildings/${schemeReference}/${schemeReference}.png`
        );
        const trustedUrl = this.$sce.valueOf(imgUrl);
        return trustedUrl;

    };

    _mapBuildings(original) {
        if (!!!original || original.length === 0) {
            return null;
        }

        let mapped = original.map((building) => {
            return {
                ...building,
                isSelected: false
            };
        });
        return mapped;
    }

    _registerEventHandling() {
        this.$timeout(() => {
            const selector =
                '#userBuildings .panel-body a, #userBuildings .panel-body a img, #userBuildings .panel-body a span';
            const $links = angular.element(selector, this.scopeReference.$element);

            $links.each((i, ele) => {
                const $ele = angular.element(ele);
                $ele.on('click', (evt) => {
                    let link;
                    const { currentTarget } = evt;

                    if (currentTarget.tagName !== 'a') {
                        link = angular.element(currentTarget).closest('a')[0];
                    } else {
                        link = currentTarget;
                    }

                    const $link = angular.element(link);
                    const buildingName = $link.text();
                    this.scopeReference.$parent.$parent.$broadcast('reload-user-units', buildingName);

                });
            });
        }, 3500);

        this.scopeReference.$watch('MainVM.selectedBuildingRef', (newValue, oldValue) => { }, true);
    }
}

export default /* @ngInject */ ($window, $timeout, $rootScope, $templateCache) =>
    new BuildingsTopNav($window, $timeout, $rootScope, $templateCache);
